// Keycloak's PUT /users/{id} is not a patch: it replaces `attributes`
// wholesale, clears profile fields left out (a save without `email` blanks
// it on Keycloak 26) and ignores `groups`.
export function buildUserUpdatePayload(user, changes) {
  const payload = {
    id: user.id,
    username: user.username,
    firstName: changes.firstName,
    lastName: changes.lastName,
    attributes: changes.attributes,
    enabled: true
  }
  if (user.email !== undefined) {
    payload.email = user.email
  }
  if (user.emailVerified !== undefined) {
    payload.emailVerified = user.emailVerified
  }
  return payload
}

function cleanList(list) {
  return Array.isArray(list) ? list.filter(Boolean) : []
}

// "Is Agent?" is a persona, not a partner scope: ticking it must not drop
// the user's other partners. Pass activePartner only for an agent, who
// needs at least one.
export function partnersForSave(selectedPartners, activePartner) {
  const selected = cleanList(selectedPartners)
  if (selected.length > 0 || !activePartner) {
    return selected
  }
  return [activePartner]
}

export function withActivePartner(existingPartners, activePartner) {
  const existing = cleanList(existingPartners)
  if (!activePartner || existing.indexOf(activePartner) !== -1) {
    return existing
  }
  return existing.concat([activePartner])
}
